import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { api } from 'gen/rtk-openapi'
import uiReducer from './ui'
import authReducer from './auth'
import inboundTicketReducer from './inboundTicket'
import customerReducer from './customer'
import outboundTicketReducer from './outboundTicket'
import purchaseOrderReducer from './purchaseOrder'
import salesOrderReducer from './salesOrder'
import permissionsReducer from './permissions'
import deviceReducer from './devices'
import settingsReducer from './settings'
import customerContactsReducer from './customer/customerContactsSlice'
import paymentInfoReducer from './payment'
import featureFlagsReducer from './featureFlags'
import dispatchReducer from './dispatch'
import materialsReducer from './materials'
import billReducer from './bill'
import loadingReducer from './loading'
import inventoryReducer from './inventory'
import ledgerReducer from './ledger'
import invoicesReducer from './invoices'

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    ui: uiReducer,
    auth: authReducer,
    inboundTicket: inboundTicketReducer,
    customer: customerReducer,
    customerContacts: customerContactsReducer,
    outboundTicket: outboundTicketReducer,
    purchaseOrder: purchaseOrderReducer,
    salesOrder: salesOrderReducer,
    permissions: permissionsReducer,
    devices: deviceReducer,
    settings: settingsReducer,
    paymentInfo: paymentInfoReducer,
    featureFlags: featureFlagsReducer,
    dispatch: dispatchReducer,
    materials: materialsReducer,
    bill: billReducer,
    loading: loadingReducer,
    inventory: inventoryReducer,
    ledger: ledgerReducer,
    invoices: invoicesReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware),
})

setupListeners(store.dispatch)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {ui: UiState, inboundTicket: InboundTicketState etc....}
export type AppDispatch = typeof store.dispatch

export default store
